"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var A_Button = __importStar(require("./A_Button"));
var reverseLeft_1 = require("./icons/reverseLeft");
var reverseRight_1 = require("./icons/reverseRight");
var Check_1 = __importDefault(require("@mui/icons-material/Check"));
var Component = function (p) { return (Preact.h(Box_1.default, { sx: {
        backgroundColor: 'background.default',
        display: 'flex',
        justifyContent: p.done ? 'space-between' : 'flex-start',
        alignItems: 'center',
        width: '100%',
        paddingX: '12px',
        boxSizing: 'border-box',
        borderTop: '1px #E0E0E0 solid',
    } },
    Preact.h(Box_1.default, { sx: {
            display: 'flex',
            gap: { xs: '6px', md: '11px' },
            height: { xs: '58px', md: '64px' },
        } },
        Preact.h(A_Button.Component, { startIcon: Preact.h(reverseLeft_1.ReverseLeft, { fontSize: "medium" }), disabled: !p.undo, color: "secondary", onClick: p.undo }, p.undoText),
        Preact.h(A_Button.Component, { endIcon: Preact.h(reverseRight_1.ReverseRight, { fontSize: "medium" }), disabled: !p.redo, color: "secondary", onClick: p.redo }, p.redoText)),
    p.done && (Preact.h(A_Button.Component, { startIcon: Preact.h(Check_1.default, null), size: "large", variant: "contained", onClick: p.done, disabled: p.doneDisabled }, p.doneText)))); };
exports.Component = Component;
